import _ from 'underscore';
import ko from 'knockout';

function translateLanguageName(i18n, language) {
  return i18n.getString(`Language_${language}`);
}

export default class ViewModel {
  constructor({
    selectedLanguages,
    suggestedLanguages,
    i18n,
    allLanguageExclusive,
    inEditMode,
    languages,
  }) {
    this.ALL_LANGUAGES = 'All';
    this.i18n = i18n;

    // make 'All' the first language
    let languagesSet = languages || [];

    if (_.contains(languagesSet, this.ALL_LANGUAGES)) {
      languagesSet = _.without(languagesSet, this.ALL_LANGUAGES);
      languagesSet.unshift(this.ALL_LANGUAGES);
    }

    this.allLanguageExclusive = ko.observable(allLanguageExclusive);

    this.inEditMode = ko.observable(inEditMode);

    this.languageOptions = _.map(languagesSet, language => (
      {
        Text: translateLanguageName(i18n, language),
        Value: language,
      }
    ));

    this.selectedLanguages = ko.observableArray(_.intersection(languagesSet, selectedLanguages));

    this.selectedLanguagesName = ko.computed(() =>
      _.map(this.selectedLanguages() || [], x => translateLanguageName(this.i18n, x)));

    this.suggestedLanguages = ko.observableArray(suggestedLanguages);

    this.suggestedLanguagesName = ko.computed(() =>
      _.map(this.suggestedLanguages(), x => translateLanguageName(this.i18n, x)));

    this.allLanguageSelected = ko.computed(() =>
      _.contains(this.selectedLanguages(), this.ALL_LANGUAGES));

    this.targetSuggestedLanguages = () => {
      this.inEditMode(true);
      this.selectedLanguages(this.suggestedLanguages() || []);
      this.suggestedLanguages([]);
      return true;
    };

    this.updateSuggestedLanguages = (newSuggestedLanguages) => {
      this.suggestedLanguages(_.intersection(newSuggestedLanguages, languagesSet));
    };
  }
}
